import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import createSagaMiddleware from "redux-saga";
import rootReducer, { RootState } from "./reducer";
import rootSaga from "./saga";
import storage from "./storage";

const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ["loading", "alert"],
  stateReconciler: autoMergeLevel2,
};

const pReducer = persistReducer<RootState>(persistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: pReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      immutableCheck: false,
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

setupListeners(store.dispatch);

export { persistor };

export default store;
